module.exports = __webpack_public_path__ + "static/media/location-verde.7b761bfc.svg";